
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import InvoiceModal from './components/invoicemodal.vue';
import canvasPhotoIndex from '@/components/canvasPhoto/index.vue';
import lazyInject from '@/di';
import InvoiceService from '@/services/invoice.service';
import moment from 'moment';
import LookCOeder from './components/lookCOeder.vue';
import RejectModal from './components/rejectModal.vue';
import { AuthEnum } from '@/services/permission.service';

/**
 * 自定义表格配置接口
 */
interface TableConfig {
  headers: string[];
  data: string[][];
  fontSize?: number;
  fontFamily?: string;
  headerBackground?: string;
  headerTextColor?: string;
  cellPadding?: number;
  borderColor?: string;
  borderWidth?: number;
  textAlign?: 'left' | 'center' | 'right';
}
@Component({
  components: {
    InvoiceModal,
    canvasPhotoIndex,
    'look-coeder': LookCOeder,
    'reject-modal': RejectModal,
  },
})
export default class Invoice extends Vue {
  @Ref('invoiceModal')
  invoiceModal!: InvoiceModal;

  @Ref('canvasPhotoIndex')
  canvasPhotoIndex!: canvasPhotoIndex;

  @Ref('lookCOeder')
  lookCOeder!: LookCOeder;

  @Ref('rejectModal')
  rejectModal!: RejectModal;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  AuthEnum = AuthEnum;

  tabType = '1';

  invoiceManageInvoicingBatch: any[] = [];

  form: any = {
    apply_time_start: '',
    apply_time_end: '',
    batch_no: '',
    status: 0,
    title: '',
    invoice_category: undefined,
  };

  applyTime: any[] = [];

  get columns() {
    return [
      {
        title: this.tabType === '5' ? 'ID' : '批次号',
        dataIndex: this.tabType === '5' ? 'id' : 'batch_no',
        align: 'center',
        width: 180,
        customRender: (text: any) => {
          return text || '--';
        },
      },
      {
        title: '申请时间',
        dataIndex: 'apply_time',
        align: 'center',
        width: 180,
      },
      {
        title: '订单类型',
        dataIndex: 'category',
        align: 'center',
        width: 120,
        customRender: (text: any) => {
          return Number(text) === 1 ? '抽佣订单' : '';
        },
      },
      {
        title: '发票分类',
        dataIndex: 'invoice_category_str',
        align: 'center',
        width: 180,
      },

      {
        title: '抬头类型',
        dataIndex: 'buyer_category',
        align: 'center',
        width: 120,
      },
      {
        title: '发票抬头',
        dataIndex: 'buyer_title',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'buyer_title' },
      },
      {
        title: '企业税号',
        dataIndex: 'buyer_tax_no',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'buyer_tax_no' },
      },
      {
        title: '开户行',
        dataIndex: 'buyer_bank_name',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'buyer_bank_name' },
      },
      {
        title: '发票金额',
        dataIndex: 'credit',
        align: 'center',
        width: 120,
      },
      {
        title: '发票商品名称',
        dataIndex: 'goods_name',
        align: 'center',
        width: 180,
      },

      // {
      //   title: '开票日期',
      //   dataIndex: 'invoice_date',
      //   align: 'center',
      //   width: 120,
      //   customRender: (text: any) => {
      //     if (text === '0000-00-00') {
      //       return '--';
      //     }
      //     return text;
      //   },
      // },
      {
        title: '发票开具方',
        dataIndex: 'invoice_from',
        align: 'center',
        width: 180,
      },
      {
        title: '状态',
        dataIndex: 'status_str',
        align: 'center',
        width: 120,
      },
      {
        title: '操作',
        dataIndex: 'action',
        fixed: 'right',
        scopedSlots: { customRender: 'action' },
        align: 'center',
        width: 160,
      },
    ];
  }

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    onChange: this.paginationChange,
  };

  invoiceData: any[] = [];
  selectedRowKeys: any[] = [];

  @Watch('$route.query')
  onQueryChange() {
    const {
      page,
      pageSize,
      title,
      status,
      invoice_category,
      applyTimeStart,
      applyTimeEnd,
      batch_no,
    } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      category: this.tabType,
    };
    if (title) {
      query.title = title;
      this.form.title = title;
    }
    if (status !== undefined) {
      query.status = status;
      this.form.status = +status;
    } else {
      query.status = 0;
      this.form.status = 0;
    }
    if (invoice_category) {
      query.invoice_category = invoice_category;
      this.form.invoice_category = invoice_category;
    }
    if (applyTimeStart && applyTimeEnd) {
      query.apply_time_start = applyTimeStart;
      query.apply_time_end = applyTimeEnd;
      this.applyTime = [
        moment(applyTimeStart as string),
        moment(applyTimeEnd as string),
      ];
      this.form.apply_time_start = applyTimeStart;
      this.form.apply_time_end = applyTimeEnd;
    }
    if (batch_no) {
      query.batch_no = batch_no;
      this.form.batch_no = batch_no;
    }
    if (Number(status) === 1 && this.invoiceManageInvoicingBatch.length === 0) {
      this.getInvoiceManageInvoicingBatch('0');
    }
    this.handleSubmit(query);
  }

  handleEdit(record: any, type: string) {
    // console.log(record);
    this.invoiceModal.init(record, type);
  }

  handleOrder(record: any) {
    this.lookCOeder.init(record);
  }

  handleDelete(record: any) {
    this.invoiceRecord = record;
    const _D = {
      orderId: 1041112,
      packgeName: '基础服务(全年)',
      regionName: '河北省石家庄市',
      shopName: '运通汽车贴车',
      shopId: 332212441,
      poi: 'B0FFKW51J2',
      staffName: '',
      createTime: '2025-03-22 18:19:21',
      isPay: '已支付',
      payChannel: '企业转账',
      payPrice: 3000,
      amount: null,
      payTime: '2025-03-22 18:19:21',
      note: '品牌门店批量导入',
      giveDuration: 30,
      status: null,
      type: '年费转年费',
      guidePrice: 0,
      passAdOrderFlag: false,
      append_remark: '',
      is_region_cover: true,
      history_price: '无',
      onsite_service_flag: 0,
    };

    // 定义表格数据
    const tableConfig: TableConfig = {
      headers: [
        `id:${_D.orderId}`,
        `套餐:${_D.packgeName}`,
        `省/直辖市:${_D.regionName}`,
        `店铺名称:${_D.shopName}`,
      ],
      data: [
        [
          `店铺ID:${_D.shopId}`,
          `POIID:${_D.poi}`,
          `地推员:${_D.staffName}`,
          `创建时间:${_D.createTime}`,
        ],
        [
          `订单类型:${_D.type}`,
          `赠送天数:${_D.giveDuration}`,
          `付款情况:${_D.isPay}`,
          `付款方式:${_D.payChannel}`,
        ],
        [
          `指导价格:${_D.guidePrice}`,
          `付款金额:${_D.payPrice}`,
          `支付时间:${_D.payTime}`,
          `历史开单价:${_D.history_price}`,
        ],
        [
          `备注:${_D.note}`,
          `上门服务:${_D.onsite_service_flag}`,
          `订单开城状态:${_D.status}`,
          `追加备注:${_D.append_remark}`,
        ],
      ],
      fontSize: 18,
      headerBackground: '#fff',
      headerTextColor: '#333',
      borderColor: '#fff',
      textAlign: 'left',
    };
    // console.log(record, 'tableConfig');
    // 绘制表格
    // drawTable(canvas, tableConfig);
    this.canvasPhotoIndex.initCanvas(tableConfig);
  }

  handleReject(val: any) {
    this.rejectModal.init(val);
  }

  onSelectChange(selectedRowKeys: any[]) {
    this.selectedRowKeys = selectedRowKeys;
  }

  handleInvoice(record: any) {
    if (!this.form.batch_no) {
      this.$message.error('请先按批次号搜索');
      return;
    }
    if (this.selectedRowKeys.length === 0) {
      this.$confirm({
        title: '提示',
        content: '当前未勾选任何开票记录，当前批次所有开票记录将被标记为已开票',
        onOk: () => this.invoiceManageInvoiced(record),
        onCancel() {},
      });
    } else {
      this.$confirm({
        title: '提示',
        content: '确定将当前已勾选的开票记录标记为已开票吗？',
        onOk: () => this.invoiceManageInvoiced(record),
        onCancel() {},
      });
    }
  }

  invoiceInvoiced() {
    if (this.selectedRowKeys.length) {
      this.$confirm({
        title: '提示',
        content: '确定将当前已勾选的开票记录标记为已开票吗？',
        onOk: async () => {
          const res = await this.invoiceService.invoiceManageInvoicedById({
            ids: this.selectedRowKeys,
          });
          if (res) {
            this.$message.success('标记成功');
            this.selectedRowKeys = [];
            this.onQueryChange();
          }
        },
        onCancel() {},
      });
    } else {
      this.$message.error('请先勾选开票记录');
    }
  }
  invoiceRecord: any = {};
  async invoiceManageInvoiced(record: any) {
    // console.log(record);
    // console.log(this.selectedRowKeys);
    this.invoiceRecord = record;
    const _d = {
      batch_no: this.form.batch_no,
      ids: this.selectedRowKeys,
    };
    const res = await this.invoiceService.invoiceManageInvoiced(_d);
    if (res) {
      this.$message.success('标记成功');
      this.selectedRowKeys = [];
      this.onQueryChange();
    }
  }

  refresh() {}

  search() {
    const {
      apply_time_start,
      apply_time_end,
      status,
      invoice_category,
      title,
      batch_no,
    } = this.form;
    const { pageSize } = this.pagination;
    const query: any = {
      page: 1,
      pageSize: pageSize || 10,
    };
    if (apply_time_start) {
      query.applyTimeStart = apply_time_start;
    }
    if (apply_time_end) {
      query.applyTimeEnd = apply_time_end;
    }
    if (status !== undefined) {
      query.status = status;
    }
    if (invoice_category) {
      query.invoice_category = invoice_category;
    }
    if (title) {
      query.title = title;
    }
    if (batch_no) {
      query.batch_no = batch_no;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }
  async exportInvoice() {
    const {
      apply_time_start,
      apply_time_end,
      status,
      invoice_category,
      title,
      batch_no,
    } = this.form;
    const query: any = {
      category: this.tabType,
    };
    if (apply_time_start) {
      query.apply_time_start = apply_time_start;
    }
    if (apply_time_end) {
      query.apply_time_end = apply_time_end;
    }
    if (status !== undefined) {
      query.status = status;
    }
    if (invoice_category) {
      query.invoice_category = invoice_category;
    }
    if (title) {
      query.title = title;
    }
    if (batch_no) {
      query.batch_no = batch_no;
    }
    const res = await this.invoiceService.invoiceManageExport(query);
    // console.log(res, 'res');
    if (res) {
      if (Object.prototype.toString.call(res) !== '[object ArrayBuffer]') {
        return;
      }
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month =
        currentDate.getMonth() + 1 < 10
          ? `0${currentDate.getMonth() + 1}`
          : currentDate.getMonth() + 1;
      const day =
        currentDate.getDate() < 10
          ? `0${currentDate.getDate()}`
          : currentDate.getDate();
      let _t = `抽佣订单开票申请模板-${year}-${month}-${day}.xlsx`;
      if (this.tabType === '1') {
        _t = `抽佣订单开票申请模板-${year}-${month}-${day}.xlsx`;
      } else {
        _t = `自营品订单开票列表-${year}-${month}-${day}.xlsx`;
      }
      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = _t;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.onQueryChange();
    }
  }

  changeTab(val: any) {
    this.tabType = val;
    this.callback('0');
  }

  callback(key: any) {
    this.form.status = key;
    this.selectedRowKeys = [];
    this.invoiceData = [];
    this.form.batch_no = undefined;
    if (key === 1) {
      this.getInvoiceManageInvoicingBatch('1');
    } else {
      this.search();
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const {
      apply_time_start,
      apply_time_end,
      status,
      invoice_category,
      title,
      batch_no,
    } = this.form;
    const query: any = {
      page,
      pageSize,
    };
    if (apply_time_start) {
      query.applyTimeStart = apply_time_start;
    }
    if (apply_time_end) {
      query.applyTimeEnd = apply_time_end;
    }
    if (status !== undefined) {
      query.status = status;
    }
    if (invoice_category) {
      query.invoice_category = invoice_category;
    }
    if (title) {
      query.title = title;
    }
    if (batch_no) {
      query.batch_no = batch_no;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }
  reset() {
    const { status } = this.$route.query;
    this.form = {
      apply_time_start: '',
      apply_time_end: '',
      batch_no: '',
      status: status || 0,
      title: '',
      invoice_category: undefined,
    };
    this.pagination.current = 1;
    const applyTimeStart = `${moment()
      .subtract(1, 'month')
      .format('YYYY-MM-DD')}`;
    const applyTimeEnd = `${moment().format('YYYY-MM-DD')}`;
    this.applyTime = [moment(applyTimeStart), moment(applyTimeEnd)];
    this.form.apply_time_start = applyTimeStart;
    this.form.apply_time_end = applyTimeEnd;
    const query: any = {
      page: 1,
      pageSize: 10,
      applyTimeStart,
      applyTimeEnd,
      status: status || 0,
    };
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  async handleSubmit(query: any) {
    const _q = { ...query };
    if (Number(query.status) === 1) {
      if (query.batch_no) {
        delete _q.apply_time_end;
        delete _q.apply_time_start;
      } else {
        return;
      }
    }
    const res = await this.invoiceService.getInvoiceManageList(_q);
    this.invoiceData = res.list;
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }

  handleChange(value: any) {
    // console.log(value);
    this.applyTime = value;
    if (value[0] && value[1]) {
      this.form.apply_time_start = value[0].format('YYYY-MM-DD');
      this.form.apply_time_end = value[1].format('YYYY-MM-DD');
    } else {
      this.form.apply_time_start = '';
      this.form.apply_time_end = '';
    }
  }

  mounted() {
    this.onQueryChange();
  }

  async getInvoiceManageInvoicingBatch(status: string) {
    const res = await this.invoiceService.getInvoiceManageInvoicingBatch({});
    this.invoiceManageInvoicingBatch = res;
    this.form.batch_no = this.invoiceManageInvoicingBatch[0]?.batch_no;
    if (Number(status) === 1) {
      this.search();
    }
  }
}
